export interface ImsStandard {
  code: string;
  name: string;
  programme: string;
  capabilities: string[];
  edition?: string;
  publisherUrl?: string;
  criteriaState?: string;
}

export interface ImsProgrammeAction {
  key: string;
  summary: string;
  status: string;
  statusCategory: string | null;
  assignee: string | null;
  dueDate: string | null;
  labels: string[];
  updatedAt: string | null;
}

export interface ImsOverview {
  generatedAt: string;
  standards: ImsStandard[];
  sourceSnapshot: { snapshotAt: string | null; source: string | null; scope: string | null };
  migration: {
    state?: string;
    sourceSystem?: string;
    targetSystem?: string;
    cutoverPermitted?: boolean;
    cutoverGate?: string;
    reconciliation?: { status?: string; normalizedRecordCount?: number };
    archive?: { name?: string; sha256?: string; fileCount?: number };
  };
  recordCounts: Record<string, number>;
  health: Record<string, number>;
  programmeActions: { epic: string; project?: string; scope?: string; total: number; statusCounts: Record<string, number>; items: ImsProgrammeAction[] };
  links: { sharePointEvidence: string; jiraEpic: string };
}

export const imsTimestamp = (value: string | null | undefined): string => {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Not recorded' : date.toLocaleString('en-GB');
};

export const imsDate = (value: string | null | undefined): string => {
  if (!value) return 'Not set';
  const date = new Date(`${value.slice(0, 10)}T12:00:00Z`);
  return Number.isNaN(date.getTime()) ? 'Not set' : date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};
